module.exports = __webpack_public_path__ + "static/media/Downstream_2.7d839bf7.png";